import React from 'react';
import OmnitureUtils from '../../../../../../common/utils/Omniture/OmnitureUtils';

import './styles.scss';

const FilterHeader = ({ name, handleCollapsed, isCollapsed, filterIndex }) => {
  const activeArrow = isCollapsed === true ? ' mmt-chevron-up' : ' mmt-chevron-down';

  const handleArrowClick = () => {
    OmnitureUtils.trackClickEvent({
      prop54: `${name}_${filterIndex}_${isCollapsed ? 'collapse' : 'expand'}`,
    });
    handleCollapsed();
  };

  return (
    <div className="filterHeadouter" onClick={handleArrowClick}>
      <span className="filtersHead">{name}</span>
      <span className={`icon ${activeArrow}`} />
    </div>
  );
};

export default FilterHeader;
